export default __webpack_public_path__ + "static/Miljofyrtarn-968f9b3126cf3be7fc4c4447614132fd.png";